<template>
  <div class="has-border-light has-border-radius p-4 is-full-height is-full-width">
    <div class="bottom-border pb-4 px-4"><slot name="header" /></div>
    <div class="pt-4"><slot name="body" /></div>
  </div>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'HeaderBodyCard',
  slotsDefinition: {
    header: {},
    body: {}
  }
};
</script>

<style scoped>
div.bottom-border {
  border-bottom: var(--ce-primary) var(--ce-2px) solid;
  border-radius: inherit;
}
</style>
